import React from 'react';

const RightStep = ({number, title, text, image}) => {
    return (
        <div className="product-step -right">
            <span className="number">{number}</span>
            <div className="text-container">
                <h4 dangerouslySetInnerHTML={{ __html: title }}></h4>
                <p>{text}</p>
            </div>
            <figure>
                <img src={image} alt={title}/>
            </figure>
            {/* <a className="cta" href="#">
                <Isvg src={iconPlus} />
                Saiba mais
            </a> */}
        </div>
    );
};

export default RightStep;


// WEBPACK FOOTER //
// ./src/components/ProductStep/RightStep.js